export function PrinciplesSection() {
  return (
    <section className="space-y-6 bg-muted/30 rounded-xl py-10 px-4">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-display font-bold">Bygget på prinsipper for mestring</h2>
        <p className="text-muted-foreground max-w-md mx-auto text-sm">
          Flyt bygger på prinsipper som styrker selvregulering og langsiktig mestring hos barn.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg mx-auto">
        {[
          { title: "Små, tydelige steg", desc: "Oppgaver fullføres én og én. Det øker gjennomføring." },
          { title: "Synlig fremgang", desc: "Progresjon over tid styrker motivasjon når den brukes som støtte – ikke press." },
          { title: "Eierskap hos barnet", desc: "Barnet ser sin egen plan – uten feed, uten støy." },
          { title: "Rolig design", desc: "Ingen annonser. Ingen uendelig scroll. Ingen varsler som lokker." },
        ].map((item) => (
          <div key={item.title} className="space-y-1 p-4">
            <p className="font-display font-bold text-sm">{item.title}</p>
            <p className="text-sm text-muted-foreground">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
